<template>
  <div>
    <a-row :gutter="20">
      <a-col :span="16" class="left-panel">
        <div class="title info-row">
          数据范围选择
        </div>
        <div>
          <div class="group-title info-row">
            选择分中心
          </div>
          <div class="group-title info-row">
            <a-checkbox v-if="!data.id" :indeterminate="center.indeterminate" :checked="center.checkAll" @change="centerCheckChange($event,center)">
              全选
            </a-checkbox>
          </div>
          <a-checkbox-group v-model="center.checkedList" @change="onCenterCheckGroupChange($event,center)" style="width: 100%" class="info-row">
            <a-row >
              <a-col :span="6" v-for="(item,index) in center.dataList" :key="index">
                <a-checkbox :value="item.value">
                  {{item.text}}
                </a-checkbox>
              </a-col>
            </a-row>
          </a-checkbox-group>
        </div>
        <div>
          <div class="group-title info-row">
            选择组别
          </div>
          <div class="group-title info-row">
            <a-checkbox  v-if="!data.id" :indeterminate="group.indeterminate" :checked="group.checkAll" @change="centerCheckChange($event,group)">
              全选
            </a-checkbox>
          </div>
          <a-checkbox-group v-model="group.checkedList" @change="onCenterCheckGroupChange($event,group)" style="width: 100%" class="info-row">
            <a-row >
              <a-col :span="6" v-for="(item,index) in group.dataList" :key="index">
                <a-checkbox :value="item.value">
                  {{item.text}}
                </a-checkbox>
              </a-col>
            </a-row>
          </a-checkbox-group>
        </div>
      </a-col>
      <a-col :span="8" class="right-panel">
        <div class="title info-row">
          导出结构配置
        </div>
        <div class=" group-title info-row">
          导出格式：excel
        </div>
        <div class="export-btn" >
          <a-button type="primary" @click="createExportHandle" :loading="loading" v-if="!data.id">导出</a-button>
        </div>
      </a-col>
    </a-row>
  </div>
</template>

<script>
  import manyCheck from '@/utils/components/manyCheck'
  import { getAction,postAction } from '@/api/manage'
  import { CACHE_PROJECT_ID,CACHE_PROJECT_NAME } from '@/constants/project'
  import Vue from 'vue'
  export default {
    name: 'Type7',
    props:{
      data:{
        type:Object,
        default(){
          return {}
        }
      }
    },
    data(){
      return {
        loading:false,
        projectId:Vue.ls.get(CACHE_PROJECT_ID) ||'',
        center:{
          indeterminate:false,
          checkedList:[],
          checkAll:true,
          dataList:[
            // {text:'四川大学华西医院',value:'HX'},
          ]
        },
        group:{
          indeterminate:false,
          checkedList:[
            // '1'
          ],
          checkAll:true,
          dataList:[
            // {text:'运动损伤队列',value:'1'},
          ]
        },
      }
    },
    methods:{
      loadDataView(){
        //回显
        if(this.data.id){
          {
            // centerIds
            if(this.data.centerIds){
              this.center.checkedList =this.data.centerIds.split(',')
            }
          }
          {
            // groupIds
            if(this.data.groupIds){
              this.group.checkedList =this.data.groupIds.split(',')
            }
          }
        }
      },
      loadData(){
        this.loadDataView()
        // 中心
        getAction('/project/center/listAll',{projectId:this.projectId}).then(res=>{
          if(res.success){
            const checkedList = []
            const dataList = []
            res.result.forEach(center=>{
              checkedList.push(center.centerId);
              const centerInfo = {
                text:center.center.name,
                value:center.centerId,
              }
              dataList.push(centerInfo)
            })
            this.$set(this.center,'dataList',dataList)
            if(!this.data.id){
              this.$set(this.center,'checkedList',checkedList)
            }
          }
        })
        // 组别
        getAction('/project/projectGroup/list',{projectId:this.projectId}).then(res=>{
          if(res.success){
            const checkedList = []
            const dataList = []
            res.result.forEach(data=>{
              checkedList.push(data.id);
              const dataInfo = {
                text:data.name,
                value:data.id
              }
              dataList.push(dataInfo)
            })
            this.$set(this.group,'dataList',dataList)
            if(!this.data.id){
              this.$set(this.group,'checkedList',checkedList)
            }
          }
        })
      },
      centerCheckChange(e,groupInfo){
        manyCheck.centerCheckChange(e,groupInfo)
      },
      onCenterCheckGroupChange(e,groupInfo,parent){
        manyCheck.onCenterCheckGroupChange(e,groupInfo,parent)
      },
      createExportHandle(){
        const centerIds = this.center.checkedList.join(',')
        if(!centerIds){
          return this.$message.warning('请选择中心');
        }
        const groupIds = this.group.checkedList.join(',')
        if(!groupIds){
          return this.$message.warning('请选择组别');
        }
        const params = {
          centerIds:centerIds,
          groupIds:groupIds,
          formatType:'1',
          projectId:this.projectId,
          type:'7'
        }
        this.loading = true
        postAction('/export/projectExport/create',params).then(res=>{
          if(res.success){
            this.$emit("back")
            this.$message.success(res.message)
          }else{
            this.$message.success(res.message)
          }
        }).finally(()=>{
          this.loading = false
        })
      }
    }
  }
</script>

<style scoped>

</style>